import BaseApi from "@/core/HttpResources/BaseApi";

export default class ExternalService {
    async getCNIInvestigatorByName(fullName: string): Promise<any> {
        let baseApi = new BaseApi(`ExternalService/CNIInvestigators/name/${fullName}`);
        return new Promise<any>((resolve, reject) =>
            baseApi.request(
                "GET",
                String(),
                null,
                {},
                response => resolve(response.data),
                reject,
                () => { }
            )
        );
    }

    async verifyCNIInvestigator(fullName: string, code:string): Promise<boolean> {
        let baseApi = new BaseApi(`ExternalService/CNIInvestigators/verify?name=${fullName}&code=${code}&a=0`);
        return new Promise<any>((resolve, reject) =>
            baseApi.request(
                "GET",
                String(),
                null,
                {},
                response => resolve(response.data),
                reject,
                () => { }
            )
        );
    }
  }